export default __webpack_public_path__ + "static/media/ultra4.f6eecda4.png";